import { ReactNode } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { PRICE_APPLICATION_NOT_ALLOWED_MESSAGE } from './constants';
import styles from './AppyPricesButton.module.scss';

type ApplyPermissionTooltipProps = {
  children: ReactNode;
};

const ApplyPermissionTooltip = ({ children }: ApplyPermissionTooltipProps) => (
  <Whisper trigger="hover" placement="top" speaker={<Tooltip>{PRICE_APPLICATION_NOT_ALLOWED_MESSAGE}</Tooltip>}>
    <span className={styles.disabledWrapper} data-testid="apply-prices-permission-locked">
      {children}
    </span>
  </Whisper>
);

export { ApplyPermissionTooltip };
